import React from 'react';
import { isEmpty } from 'lodash';
import ReactSelect, { Props } from 'react-select';
import useTranslation from '../../../../Hooks/useTranslation';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './Select.module.scss';

const REACT_SELECT_STYLES = {
	control: () => ({
		borderColor: 'red !important',
	}),
};

export interface SelectValueProps {
	value: string | number | object;
	label: string;
}

export interface SelectProps extends Props {
	name: string;
	hasError?: boolean;
	className?: string;
	options: SelectValueProps[];
	value?: SelectValueProps;
	shouldTranslateValues?: boolean;
	children?: React.ReactNode;
	placeholder?: string;
	portal?: boolean;
	isFixed?: boolean;
	isSearchable?: boolean;
}

// Any because of `react-select` ref type doesn't support `HTMLSelectElement`.
const Select = React.forwardRef<any, React.PropsWithChildren<SelectProps>>(
	(
		{
			value,
			hasError = false,
			options,
			className,
			children,
			shouldTranslateValues = true,
			placeholder = 'base.shared.pick',
			portal,
			isFixed,
			isSearchable,
			...props
		}: SelectProps,
		ref,
	) => {
		const { t } = useTranslation();

		return (
			<>
				<ReactSelect
					value={isEmpty(value) ? null : value}
					className={joinClasses([
						className,
						hasError ? styles.invalid : undefined,
					])}
					defaultValue={value}
					options={
						shouldTranslateValues
							? options.map(({ label, ...rest }) => ({
									...rest,
									label: t(label),
							  }))
							: options
					}
					classNamePrefix={'reactSelect'}
					styles={hasError ? REACT_SELECT_STYLES : undefined}
					ref={ref}
					menuPosition={isFixed ? 'fixed' : 'absolute'}
					placeholder={t(placeholder)}
					menuPortalTarget={portal ? document.body : false}
					isSearchable={isSearchable}
					{...props}
				/>
				{children}
			</>
		);
	},
);

export default Select;
